__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.5.1-e0fea98-9407/_next/";